export { default as NThing, thingProps } from './src/Thing';
